import { render } from "./OUpload.vue?vue&type=template&id=cbba611c&scoped=true"
import script from "./OUpload.vue?vue&type=script&lang=js"
export * from "./OUpload.vue?vue&type=script&lang=js"

import "./OUpload.vue?vue&type=style&index=0&id=cbba611c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cbba611c"]])

export default __exports__